import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { AuthContext } from '../App';
import AppHeader from '../components/AppHeader';
import { SettingsEditor } from '../components/superadmin/SettingsEditor';
import { GoogleSheetsPanel } from '../components/GoogleSheetsPanel';
import { DomainsPanel } from '../components/DomainsPanel';
import { WebsitePanel } from '../components/WebsitePanel';
import { setBrand } from '../lib/brand';

export default function CompanySettings() {
  const { user } = useContext(AuthContext);
  const [payload, setPayload] = useState(null);
  const [denied, setDenied] = useState(false);

  useEffect(() => {
    axios.get('/company/settings').then((r) => setPayload(r.data)).catch((e) => { if (e.response?.status === 403) setDenied(true); else toast.error('Could not load settings'); });
  }, []);

  const refreshBrand = () => axios.get('/auth/me').then((r) => r.data?.company?.branding && setBrand(r.data.company.branding)).catch(() => {});

  return (
    <div style={{ minHeight: '100vh', background: '#0A0A0A', color: '#fff' }}>
      <AppHeader />
      <main style={{ maxWidth: 1200, margin: '0 auto', padding: '32px 24px' }} data-testid="company-settings-page">
        <p style={{ fontSize: 11, letterSpacing: '0.22em', textTransform: 'uppercase', color: '#A1A1AA', fontWeight: 700, margin: 0 }}>{user?.company?.name}</p>
        <h1 style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 900, fontSize: 36, textTransform: 'uppercase', margin: '4px 0 20px' }}>Company Settings</h1>
        {denied && <p data-testid="settings-denied" style={{ color: '#fbbf24' }}>Only company admins can edit settings.</p>}
        {payload && payload.editable_sections?.length === 0 && <p style={{ color: '#A1A1AA' }}>Your settings are managed by the platform administrator.</p>}
        {payload && payload.editable_sections?.length > 0 && (
          <div style={{ background: '#141414', border: '1px solid #27272A', padding: 24 }}>
            <SettingsEditor baseUrl="/company/settings" logoUrl="/company/settings/logo" sections={payload.editable_sections} initial={payload.settings} companyId={user?.company_id} onSaved={refreshBrand} />
          </div>
        )}
        {payload && payload.editable_sections?.includes('integrations') && <GoogleSheetsPanel />}
        {payload && <WebsitePanel />}
        {payload && <DomainsPanel />}
      </main>
    </div>
  );
}
